import React, { useEffect, useMemo } from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import { useCityConfig } from 'models/city'

import { QRCode } from 'local_modules/qrcode'

import { Href } from 'components/navigation'
import { Image, Text } from 'components/dataDisplay'
import { WidthContainer, WidthContainerCompensator } from 'components/layout'

import iphone from './images/iphone@2x.png'
import buttonAppStore from './images/appStore.svg'
import buttonRustore from './images/rustore.svg'
import buttonAppgallery from './images/appgallery.svg'

import s from './MobileBlock.scss'


const apps = [
  { propertyName: 'mobileAppstore', button: buttonAppStore, width: 104 },
  { propertyName: 'mobileRustore', button: buttonRustore, width: 110 },
  { propertyName: 'mobileAppgalery', button: buttonAppgallery, width: 120 },
]


const MobileBlock = (props) => {
  const { className } = props
  const { isDesktop, isTablet, isMobile } = useDevice()
  const { cityConfig, isCityConfigFetching } = useCityConfig()

  const availableApps = useMemo(() => apps.filter(({ propertyName }) => Boolean(cityConfig[ propertyName ])), [ cityConfig ])

  useEffect(() => {
    if (isDesktop) {
      availableApps.forEach(({ propertyName }) => {
        new QRCode(document.getElementById(propertyName), {
          text: cityConfig[propertyName],
          width: 104,
          height: 104,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        })
      })
    }
  }, [ availableApps, cityConfig, isDesktop ])

  return (
    <WidthContainerCompensator className={cx(className, s.container, 'bg-rush')}>
      <WidthContainer
        className={cx('flex w-full justify-center', {
          [s.pt88]: isDesktop,
          'py-64px': isTablet,
          'py-48px': isMobile,
        })}
      >
        {
          isDesktop && (
            <Image
              className={s.iphone}
              src={iphone}
              tag="div"
            />
          )
        }
        <div
          className={cx(s.info, 'w-full', {
            'flex': !isMobile,
            'ml-64px mb-64px flex-col': isDesktop,
          })}
        >
          <div className={isDesktop ? null : 'flex-1'}>
            <Text
              className={isTablet ? 'mw-349' : null}
              message="Установите мобильное приложение «Умный город» на ваш смартфон"
              size="h24"
            />
            <Text
              className="mt-16px opacity-72"
              message="Все городские сервисы всегда под рукой"
              size="t16-20"
            />
          </div>
          <div
            className={cx({
              'flex mt-40px': isDesktop,
              'ml-24px': isTablet,
              'flex flex-col mt-24px': isMobile,
            })}
          >
            {
              availableApps?.map(({ propertyName, button, width }, index) => (
                <div
                  className={index ? cx('flex flex-col items-center', {
                    'flex-1 ml-96px': isDesktop,
                    'mt-24px': isTablet || isMobile,
                  }) : 'flex flex-col items-center'}
                >
                  <Href toTab={cityConfig[propertyName]}>
                    <Image src={button} alt={propertyName} height="48" width={String(width)} />
                  </Href>
                  {
                    isDesktop && (
                      <div id={propertyName} />
                    )
                  }
                </div>
              ))
            }
          </div>
        </div>
      </WidthContainer>
    </WidthContainerCompensator>
  )
}

export default MobileBlock